<template>
  <div class="increment-service production-platform" v-show="showSideBar">
    <Sidebar
      :default-active="defaultActive"
      :menu-data="menuData"
      :router="false"
      @routerChange="routerChange"
    />
  </div>
</template>
<script>
import { getItem, matchRouteObj, Get } from '@kc/common/index.js'
import { ProjectConfig } from '@/api'
import { mapState, mapGetters } from 'vuex'
import Sidebar from '@main/src/components/Sidebar'
import {
  isMedicalAssociationEnv,
  PORTAL_PRECISION_MODULE,
  PORTAL_PRECISION_PID
} from '../utils/envConfig'
import { NEW_MENU_LIST } from '../config/newMenus'
import {
  extractMenuListFromResponse,
  buildMedicalMenu,
  filterMenuByCodes,
  findFirstRoutableMenu,
  getMenuPermissionCode
} from '../utils/menuPermission'
export default {
  name: 'IncrementService',
  components: {
    Sidebar
  },
  data() {
    return {
      defaultActive: '10-1',
      isChange: true,
      menuData: [],
      defaultMenuData: [
        {
          columnName: '发文分析',
          index: '1',
          single: true,
          path: '/postAnalysis',
          icon: require('@assets/img/postAnalysis.png'),
          activeIcon: require('@assets/img/postAnalysis-active.png'),
          code: '_fwfx'
        },
        {
          title: '邮件传播',
          index: '2',
          icon: require('@assets/img/emailDissemination.png'),
          activeIcon: require('@assets/img/emailDissemination-active.png'),
          code: '_yjcb',
          childrenList: [
            {
              columnName: '邮件推送',
              parentIndex: '2',
              id: '1',
              index: '2-1',
              path: '/emailPushList',
              code: '_dpts'
            },
            {
              columnName: '阅读统计',
              parentIndex: '2',
              id: '2',
              index: '2-2',
              path: '/emailPush',
              code: '_yjcb'
            }
          ]
        },
        {
          title: '微信传播',
          index: '3',
          icon: require('@assets/img/activeCommunication.png'),
          activeIcon: require('@assets/img/activeCommunication-active.png'),
          code: '_wxcb',
          childrenList: [
            {
              columnName: '图文消息',
              parentIndex: '3',
              id: '1',
              index: '3-1',
              path: '/pictrueTextMsg',
              code: '_wxcb'
            },
            {
              columnName: '阅读统计',
              parentIndex: '3',
              id: '2',
              index: '3-2',
              path: '/weChatPush',
              code: '_wxcb'
            }
          ]
        },
        {
          columnName: '传播效果',
          index: '4',
          single: true,
          icon: require('@assets/img/citationTracking.png'),
          activeIcon: require('@assets/img/citationTracking-active.png'),
          code: '_cbxg',
          path: '/singleEffect'
        },
        {
          columnName: '传播表现推送',
          index: '5',
          single: true,
          icon: require('@assets/img/performancePush.png'),
          activeIcon: require('@assets/img/performancePush-active.png'),
          code: '_cbbxts',
          path: '/communicationEffect'
        },
        // {
        //   columnName: '引证追踪',
        //   index: '6',
        //   single: true,
        //   icon: require('@assets/img/citationTracking.png'),
        //   activeIcon: require('@assets/img/citationTracking-active.png'),
        //   code: '_yztj',
        //   path: '/citationTrackingPage'
        // },
        {
          columnName: '引证统计',
          index: '8',
          single: true,
          path: '/citationTracking',
          icon: require('@assets/img/citationStatistics.png'),
          activeIcon: require('@assets/img/citationStatistics-active.png'),
          code: '_yzzz'
        },
        {
          title: '报告下载',
          index: '7',
          icon: require('@assets/img/download.png'),
          activeIcon: require('@assets/img/download-active.png'),
          code: '_bgxz',
          childrenList: [
            {
              columnName: '单期报告',
              parentIndex: '7',
              id: '1',
              index: '7-1',
              path: '/downloadIssueReport',
              code: '_bgxz'
            },
            {
              columnName: '年度报告',
              parentIndex: '7',
              id: '2',
              index: '7-2',
              path: '/downloadYearReport',
              code: '_bgxz'
            }
          ]
        },
        ...NEW_MENU_LIST
      ]
    }
  },
  computed: {
    ...mapGetters('micro/magazine', [
      'MAGAZINE_ID',
      'centers',
      'MAGAZINE_INFO'
    ]),
    ...mapGetters(['isCluster']),
    ...mapState('producePlantForm', ['userInfo', 'isSaveSessionStorage']),
    ...mapState('micro/user', { USERINFO: 'userInfo' }),
    showSideBar() {
      let filterRouter = ['/emailPreviewHtml']
      return !filterRouter.includes(this.$route.path)
    }
  },
  watch: {
    isSaveSessionStorage(newVal) {
      if (newVal) {
        this.checkHasAuthority()
      }
      this.$nextTick(() => {
        this.isChange = true
      })
    },
    MAGAZINE_ID() {
      this.getMagByPlatId()
      if (this.$route.path) {
        this.routerChange({ path: '/' })
      }
    },
    MAGAZINE_INFO: {
      handler(newVal) {
        if (newVal) {
          // 根据 MAGAZINE_INFO.type 更新集群/单刊状态：1-集群，0-单刊
          this.$store.dispatch('updateClusterStatus', newVal)
        }
      },
      immediate: true,
      deep: true
    },
    // 监听路由变化，更新菜单激活状态
    '$route.path'() {
      const activeMenu = this.getActiveMenuByRoute()
      if (activeMenu && activeMenu !== this.defaultActive) {
        this.defaultActive = activeMenu
      }
    },
    menuData: {
      handler() {
        // 非集群下不显示模板配置菜单
        if (!this.isCluster) {
          const hasTemplateConfig = this.menuData.some((menu) =>
            menu.childrenList?.some(
              (item) => item.colCode === 'new_dyts_templateconfig'
              // item.colCode === 'new_byts_templateconfig'
            )
          )
          if (hasTemplateConfig) {
            this.menuData = this.menuData.map((menu) => {
              if (menu.childrenList) {
                return {
                  ...menu,
                  childrenList: menu.childrenList.filter(
                    (item) => item.colCode !== 'new_dyts_templateconfig'
                    // item.colCode !== 'new_byts_templateconfig'
                  )
                }
              }
              return menu
            })
          }
        }
      },
      immediate: true
    }
  },
  created() {
    // 根据当前路由路径匹配菜单
    this.defaultActive = this.getActiveMenuByRoute()
    console.log(this.getActiveMenuByRoute(), 'getActiveMenuByRoute')
    // 初始化集群/单刊状态
    if (this.MAGAZINE_INFO) {
      this.$store.dispatch('updateClusterStatus', this.MAGAZINE_INFO)
    }
  },
  mounted() {
    this.getMagByPlatId()
    this.getMenuData()
    this.$nextTick(() => {
      const el = document.getElementsByClassName('email-push')[0]
      if (el && el.clientWidth > 0) {
        this.contentWidth = el.clientWidth - 40 + 'px'
      }
    })
  },
  methods: {
    // 获取magId
    getMagByPlatId() {
      let url = ProjectConfig.increment.GetMagByPlatId?.url
      let _this = this
      Get(url).then((res) => {
        let { data } = res.data
        if (data) {
          sessionStorage.setItem('magId', data)
          _this.$store.dispatch('incrementService/magIdFun', data)
        } else {
          sessionStorage.setItem('magId', null)
          _this.$store.dispatch('incrementService/magIdFun', null)
        }
      })
    },
    /**
     * 请求 Portal 菜单权限
     */
    fetchPortalMenuPermission() {
      if (isMedicalAssociationEnv) {
        // periodicalGroup: 0=单刊(journalType=1)，1=刊群/子集群(journalType=2)
        sessionStorage.getItem('periodicalGroup') === '0' ? 1 : 2
        return Get('/portal/api/getAllMenuByMagazineIdAndUser', {
          params: {
            magazineId: this.MAGAZINE_ID,
            journalType: this.isCluster ? 2 : 1,
            magazineSource: 'cas',
            module: PORTAL_PRECISION_MODULE
          }
        })
      }

      return Get('/portal/usermagazinecentermenu', {
        params: {
          magazineid: this.MAGAZINE_ID,
          pid: PORTAL_PRECISION_PID
        }
      })
    },

    // 获取权限列表
    getMenuData() {
      this.fetchPortalMenuPermission()
        .then((res) => {
          this.applyMenuPermissionData(extractMenuListFromResponse(res))
        })
        .catch(() => {
          this.$router.push({ path: '/noData' })
        })
    },

    /** 根据 Portal 数据更新侧栏 */
    applyMenuPermissionData(portalList) {
      if (!portalList?.length) {
        this.$router.push({ path: '/noData' })
        return
      }

      if (isMedicalAssociationEnv) {
        this.menuData = buildMedicalMenu(portalList)
        // 邮件推送相关逻辑处理
        let findData = portalList.find((item) => item.colCode === 'new_zdts')
        console.log(this.$route.path, 'path')
        if (findData) {
          // 有值则存储到vuex，来控制邮件推送下菜单的显示
          if (findData.childrenList.length) {
            this.$store.dispatch(
              'incrementService/zdtsChildrenListFun',
              findData.childrenList
            )
          } else {
            // 如果子菜单为空则，邮件推送菜单也不显示
            this.menuData.forEach((item) => {
              if (item.colCode === 'new_zdts') {
                if (item.childrenList && item.childrenList.length) {
                  item.childrenList = item.childrenList.filter(
                    (childItem) => childItem.colCode !== 'new_zdts_email'
                  )
                }
              }
            })
            // 没有菜单权限不能访问邮件推送页面，跳转到工作桌面
            let yjtsFilterPath = [
              '/newActivePushEmail',
              '/steps/paperList',
              '/steps/emailTemplate',
              '/steps/selectScholars',
              '/steps/viewScholars',
              '/steps/pushTest',
              '/steps/officialPush'
            ]
            if (yjtsFilterPath.includes(this.$route.path)) {
              this.routerChange({
                path: '/newActivePushDesktop',
                index: '10-1'
              })
            }
          }
        }
      } else {
        const codes = portalList.map((item) => item.code).filter(Boolean)
        this.menuData = filterMenuByCodes(this.defaultMenuData, codes)
      }
      if (!this.menuData.length) {
        this.$router.push({ path: '/noData' })
        return
      }
      const filterRouter = [
        '/emailPreviewHtml',
        '/details',
        '/report',
        '/analysisReport',
        '/analysisYearReport',
        '/publishedJournalsDetails'
      ]
      if (filterRouter.includes(this.$route.path)) return

      let haveZDCB = false
      portalList.forEach((item) => {
        const code = getMenuPermissionCode(item)
        if (code === 'new_zdts') haveZDCB = true
        if (code === '_yztj' || code === 'new_yztj') {
          this.$store.dispatch('incrementService/isYZTJFun', true)
        }
      })

      // 菜单数据加载完成后，更新激活状态（用于页面刷新时保持菜单状态）
      this.$nextTick(() => {
        const activeMenu = this.getActiveMenuByRoute()
        if (activeMenu && activeMenu !== this.defaultActive) {
          this.defaultActive = activeMenu
        }
      })

      if (this.$route.path === '/' || this.$route.path === '') {
        console.log('haveZDCB', haveZDCB)
        if (haveZDCB) {
          if (isMedicalAssociationEnv) {
            const pushMenu = this.menuData.find((m) => m.colCode === 'new_zdts')
            const target =
              pushMenu?.childrenList?.find((c) => c.path) ||
              findFirstRoutableMenu(this.menuData)
            if (target) {
              this.routerChange({ path: target.path, index: target.index })
            }
            return
          }
          if (
            this.$route.path === '/newActivePushDesktop' &&
            this.$route.query.columnId === '10-1'
          ) {
            return
          }
          console.log(22222)

          this.routerChange({ path: '/newActivePushDesktop', index: '10-1' })
          return
        } else {
          // 当前已在阅读统计页则不重复跳转
          if (
            this.$route.path === '/emailPush' &&
            this.$route.query.columnId === '2-2'
          ) {
            return
          }
          // 有阅读统计菜单权限则跳转；无权限则跳第一个可访问菜单，避免落到无权限页面
          if (this.hasMenuPath('/emailPush')) {
            this.routerChange({ path: '/emailPush', index: '2-2' })
          } else {
            const target = findFirstRoutableMenu(this.menuData)
            if (target) {
              this.routerChange(target)
            }
          }
          return
        }
      }

      // const firstMenu = findFirstRoutableMenu(this.menuData)
      // console.log(firstMenu, 'firstMenu')
      // if (firstMenu) {
      //   this.routerChange(firstMenu)
      // }
      // }
    },
    /**
     * 根据当前路由路径获取对应的菜单激活项
     * @returns {string} 菜单项的 index
     */
    getActiveMenuByRoute() {
      const route = this.$route

      // 优先使用 query 参数中的 columnId
      if (route.query.columnId) {
        return route.query.columnId
      }

      const currentPath = route.path

      // 步骤页面路由映射：所有 /steps/* 路由都对应"新-主动推送" -> "邮件推送"
      if (currentPath.startsWith('/steps/')) {
        return '10-2' // 新-主动推送 -> 邮件推送
      }

      // 主动推送 - 基础设置及其子路由：映射到"新-主动推送" -> "基础设置"
      if (currentPath.startsWith('/newActivePushSettings')) {
        return '10-3'
      }

      // 订阅推送 - Email Alert订阅及其子路由：映射到"新-订阅推送" -> "Email Alert订阅"
      if (currentPath.startsWith('/newSubscribePushEmailAlert')) {
        return '11-2'
      }

      // 遍历菜单数据，查找匹配的菜单项
      const findMenuByPath = (menuList, path) => {
        for (const menu of menuList) {
          // 单级菜单
          if (menu.single && menu.path === path) {
            return menu.index
          }
          // 多级菜单：检查子菜单
          if (menu.childrenList && menu.childrenList.length > 0) {
            for (const child of menu.childrenList) {
              if (child.path === path) {
                return child.index
              }
            }
          }
        }
        return null
      }

      // 在默认菜单数据中查找
      const matchedIndex = findMenuByPath(this.defaultMenuData, currentPath)
      if (matchedIndex) {
        return matchedIndex
      }

      // 在已处理的菜单数据中查找（如果已加载）
      if (this.menuData && this.menuData.length > 0) {
        const matchedIndexInMenu = findMenuByPath(this.menuData, currentPath)
        if (matchedIndexInMenu) {
          return matchedIndexInMenu
        }
      }

      // 默认返回第一个菜单项
      return '1'
    },
    saveActiveTab() {
      let name = this.$route.name
      this.defaultActive = name
    },
    // 判断修改后的刊物是否有资源中心权限
    checkHasAuthority() {
      let [menuArray, flag] = [JSON.parse(getItem('mp')), false]
      menuArray.map((item, index) => {
        if (matchRouteObj[item.name] === 'incrementService') {
          flag = true
        }
        if (index === menuArray.length - 1 && !flag) {
          // 变化后的刊物没有资源中心权限 需处理
          this.$router.push({ name: matchRouteObj[menuArray[0].name] })
        }
      })
    },
    // 判断当前菜单权限中是否包含指定 path 的页面（含多级菜单的子项）
    hasMenuPath(path) {
      const list = this.menuData || []
      return list.some(
        (item) =>
          item.path === path ||
          (item.childrenList &&
            item.childrenList.some((child) => child.path === path))
      )
    },
    // 点击一级菜单
    routerChange(value) {
      this.defaultActive = value.index
      // 避免重复导航到当前路由
      const targetPath = value.path
      const targetQuery = { columnId: value.index }
      const currentPath = this.$route.path
      const currentColumnId = this.$route.query.columnId

      if (currentPath === targetPath && currentColumnId === value.index) {
        // 已经是目标路由，不执行导航
        return
      }

      this.$router
        .push({
          path: targetPath,
          query: targetQuery
        })
        .catch((err) => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
    },
    refreshCurrentPage() {
      window.location.reload()
    }
  }
}
</script>
<style lang="scss">
.increment-service {
  .cus-sidebar-item {
    > .el-menu-item {
      padding-left: 20px !important;
    }
    img.menu-icon {
      object-fit: contain;
      width: 16px !important;
      height: auto !important;
    }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.side-list {
  line-height: inherit !important;
}

.increment-service {
  height: 100%;
  .select-option {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tab-ul {
    padding: 0 !important;
    margin: 0 !important;
    background: #e4e4e4;

    li {
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #000;
      list-style: none;
      border-bottom: solid 1px #f2f2f2;

      a {
        text-decoration: none;
      }
    }
  }
  .el-menu {
    li {
      padding-left: 70px !important;

      a {
        text-align: left !important;
      }
    }
    .total-title {
      width: 100%;
      padding-left: 60px !important;
      color: #333;
      font-size: 12px;
      border: none;
    }
  }
}
</style>
